<template>
  <div id="customerServicePage">
    <ContactCustomerService></ContactCustomerService>
  </div>
</template>
<script>
import ContactCustomerService from '@/components/customerService/ContactCustomerService.vue'

export default {
  name: 'contactCustomerServicePage',
  components: {
    ContactCustomerService,
  },
  data: function() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
#customerServicePage {
  margin-bottom: -78px;
}
</style>
